export function set(name, value, minutes = 20160) {
    document.cookie = `${name}=${value}; max-age=${minutes}; path=/;`;
}

export function get(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    let cookieName = null;
    if (parts.length === 2) {
        cookieName = parts.pop().split(';').shift();
    }

    return cookieName;
}

export function has(name) {
    return !(get(name) === null || get(name) === '');
}
